// extracted by mini-css-extract-plugin
export var mt0 = "fp-7q";
export var mt1 = "fp-8q";
export var mt2 = "fp-9q";
export var mt3 = "fp-ar";
export var mt4 = "fp-br";
export var mt5 = "fp-cr";
export var mt6 = "fp-dr";
export var quote = "fp-er";
export var quoteDark = "fp-fr";
export var quoteOnForm = "fp-lr";
export var quoteTransparent = "fp-gr";
export var quoteWithImage = "fp-hr";
export var quote__author__name = "fp-rr";
export var quote__author__role = "fp-sr";
export var quote__avatar = "fp-qr";
export var quote__blockquote = "fp-kr";
export var quote__caption = "fp-pr";
export var quote__contentWrapper = "fp-jr";
export var quote__icon = "fp-ir";
export var quote__largeImage = "fp-nr";
export var quote__largeImageWrapper = "fp-mr";
export var quote__largeImage__content = "fp-or";